@let isPhablet = isPhablet$ | async;
<ul id="detail_dauer_termine" class="p-0">
  @if (termin.beginn || (!termin.ende && !termin.beginn)) {
    <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
      <span id="detail_beginn_label" class="fw-bold">Beginn</span>
      <span id="detail_beginn">
        @if (termin.beginn) {
          {{ termin.beginn | date }}
        }
        @if (!termin.ende && !termin.beginn) {
          Regelmäßiger Start
        }
      </span>
    </li>
  }

  @if (termin.ende) {
    <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
      <span id="detail_ende_label" class="fw-bold">Ende</span>
      <span id="detail_ende">
        {{ termin.ende | date }}
      </span>
    </li>
  }

  @if (termin.dauer) {
    <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
      <span id="detail_dauer_label" class="fw-bold">Dauer</span>
      <span id="detail_dauer">
        @if (isPhablet$ | async) {
          <now-wbsuche-lib-chip
            class="angebot-dauer"
            [icon]="'wbsuche-icon-duration'"
            [name]="'Dauer'"
            [single]="true"
          >
            <now-wbsuche-lib-dauer-anzeige [termin]="termin"></now-wbsuche-lib-dauer-anzeige>
          </now-wbsuche-lib-chip>
        } @else {
          <now-wbsuche-lib-dauer-anzeige [termin]="termin"></now-wbsuche-lib-dauer-anzeige>
        }
      </span>
    </li>
  }

  <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
    <span id="detail_laufender_einstieg_label" class="fw-bold">Laufender Einstieg</span>
    <span id="detail_laufender_einstieg">
      {{ termin.individuellerEinstieg ? 'ja' : 'nein' }}
      <button
        [attr.data-bs-target]="'#info-modal-' + (termin.individuellerEinstieg ? 'ja' : 'nein')"
        data-bs-toggle="modal"
        class="info-button d-print-none"
        aria-label="Weitere Informationen zum Laufenden Einstieg aufrufen"
      >
        <i class="now-icon now-icon-info" aria-hidden="true"></i>
      </button>
    </span>
  </li>

  @if (termin.anmeldeschluss) {
    <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
      <span id="detail_anmeldeschluss_label" class="fw-bold">Anmeldeschluss</span>
      <span id="detail_anmeldeschluss">
        {{ termin.anmeldeschluss | date }}
      </span>
    </li>
  }

  @if (termin.unterrichtszeiten) {
    <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
      <span id="detail_unterrichtszeiten_label" class="fw-bold">Unterrichtszeiten</span>
      <span
        class="keywords"
        id="detail_unterrichtszeiten"
        [innerHTML]="sanitizeFunction(termin.unterrichtszeiten)"
      >
      </span>
    </li>
  }

  @if (termin.bemerkungZeit) {
    <li class="d-flex flex-column" [ngClass]="isPhablet ? 'mb-1' : 'mb-2'">
      <span id="detail_bemerkung_zeit_label" class="fw-bold">Bemerkungen</span>
      <span
        id="detail_bemerkung_zeit"
        class="keywords"
        [innerHTML]="sanitizeFunction(termin.bemerkungZeit)"
      >
      </span>
    </li>
  }

  @if (termin?.veranstaltungsablaeufe?.length! > 0) {
    <li class="d-flex flex-column">
      <span id="detail_veranstaltungsablauf_label" class="fw-bold">Veranstaltungsablauf</span>
      <span id="detail_veranstaltungsablauf">
        @for (ablauf of sortVeranstaltungsablauf(termin.veranstaltungsablaeufe); track ablauf) {
          <div>
            {{ ablauf.bezeichnung }}
            @if (ablauf.beginn !== null && ablauf.ende !== null) {
              ({{ ablauf.beginn }} - {{ ablauf.ende }})
            }
          </div>
        }
      </span>
    </li>
  }
</ul>

<now-wbsuche-lib-modal-popup
  modalId="info-modal-ja"
  modalTitle="Laufender Einstieg: Ja"
  primaryButtonText="Schließen"
  secondaryButtonText=""
  ariaLabel="Hinweis zu laufendem Einstieg"
>
  <p>
    Das Weiterbildungsangebot kann nicht nur am offiziellen Veranstaltungsbeginn angetreten werden,
    sondern immer auch während des gesamten Kurses. Bitte prüfen Sie, ob die Eintrittsbedingungen
    und Eintrittsmöglichkeiten beim Anbieter bei einem späteren Eintritt noch gültig sind.
  </p>
</now-wbsuche-lib-modal-popup>
<now-wbsuche-lib-modal-popup
  modalId="info-modal-nein"
  modalTitle="Laufender Einstieg: Nein"
  primaryButtonText="Schließen"
  secondaryButtonText=""
  ariaLabel="Hinweis zu laufendem Einstieg"
>
  <p>
    Das Weiterbildungsangebot kann nach dem Veranstaltungsbeginn <b>nicht</b> mehr angetreten
    werden. Bitte prüfen Sie weitere Beginntermine bzw. weitere individuelle Eintrittsmöglichkeiten
    beim Anbieter.
  </p>
</now-wbsuche-lib-modal-popup>
